import { Card } from '@heroui/react'
import { useRouteLoaderData } from 'react-router-dom'

import type { LoaderDataAccount } from '@/guards'

export default function Account() {
	const data = useRouteLoaderData('account-root') as LoaderDataAccount | undefined
	const user = data?.user
	if (!user) return null

	return (
		<section className="space-y-6">
			<h1 className="text-2xl font-semibold">Account</h1>
			<Card className="p-4">
				<pre className="overflow-auto text-sm">{JSON.stringify(user, null, 2)}</pre>
			</Card>
		</section>
	)
}
